/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Monitoring API
 * A comprehensive portfolio monitoring and reporting tool for DeFi users to track investments/balances across multiple protocols, discover yield opportunities, and generate reports for tax and accounting purposes.  The API enables users to: - Monitor balances and earnings across lending, liquid staking, LP positions, vaults, and traditional staking - Discover new yield opportunities with advanced filtering and sorting - Generate downloadable reports for taxes, accounting, and personal tracking - Aggregate data at multiple levels (combined, by category, by protocol, by wallet) - Track performance over time with historical data
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, setSearchParams, toPathString, createRequestFunction } from '../common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base.js';
/**
 * TokensApi - axios parameter creator
 */
export const TokensApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieves a list of available tags that can be used to filter the tokens response.
         * @summary Get list of token tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenTags: async (options = {}) => {
            const localVarPath = `/portfolio/v1/tokens/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of tokens along with their metadata, such as the token\'s name, symbol, decimals, logo URI, and associated tags. This information is useful for displaying token details and allowing users to search or filter tokens based on specific criteria. Tags can be used to narrow down the returned tokens. Example: Use the tag `stablecoins` to only return stablecoin tokens.
         * @summary Get list of tokens with metadata
         * @param {string} [chainID] The CAIP-2 identifier for a blockchain.
         * @param {string} [tokenAddress] The address of an token contract to query. If omitted, all supported tokens will be queried.
         * @param {string} [tokenSymbol] The symbol of an token contract.
         * @param {Array<string>} [tagLimit] A list of token tag identifiers to include in the query.
         * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokens: async (chainID, tokenAddress, tokenSymbol, tagLimit, fiatType, options = {}) => {
            const localVarPath = `/portfolio/v1/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (chainID !== undefined) {
                localVarQueryParameter['chainID'] = chainID;
            }
            if (tokenAddress !== undefined) {
                localVarQueryParameter['tokenAddress'] = tokenAddress;
            }
            if (tokenSymbol !== undefined) {
                localVarQueryParameter['tokenSymbol'] = tokenSymbol;
            }
            if (tagLimit) {
                localVarQueryParameter['tagLimit'] = tagLimit;
            }
            if (fiatType) {
                localVarQueryParameter['fiatType'] = fiatType;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TokensApi - functional programming interface
 */
export const TokensApiFp = function (configuration) {
    const localVarAxiosParamCreator = TokensApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieves a list of available tags that can be used to filter the tokens response.
         * @summary Get list of token tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTokenTags(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTokenTags(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokensApi.getTokenTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of tokens along with their metadata, such as the token\'s name, symbol, decimals, logo URI, and associated tags. This information is useful for displaying token details and allowing users to search or filter tokens based on specific criteria. Tags can be used to narrow down the returned tokens. Example: Use the tag `stablecoins` to only return stablecoin tokens.
         * @summary Get list of tokens with metadata
         * @param {string} [chainID] The CAIP-2 identifier for a blockchain.
         * @param {string} [tokenAddress] The address of an token contract to query. If omitted, all supported tokens will be queried.
         * @param {string} [tokenSymbol] The symbol of an token contract.
         * @param {Array<string>} [tagLimit] A list of token tag identifiers to include in the query.
         * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTokens(chainID, tokenAddress, tokenSymbol, tagLimit, fiatType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTokens(chainID, tokenAddress, tokenSymbol, tagLimit, fiatType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokensApi.getTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TokensApi - factory interface
 */
export const TokensApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TokensApiFp(configuration);
    return {
        /**
         * Retrieves a list of available tags that can be used to filter the tokens response.
         * @summary Get list of token tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokenTags(options) {
            return localVarFp.getTokenTags(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of tokens along with their metadata, such as the token\'s name, symbol, decimals, logo URI, and associated tags. This information is useful for displaying token details and allowing users to search or filter tokens based on specific criteria. Tags can be used to narrow down the returned tokens. Example: Use the tag `stablecoins` to only return stablecoin tokens.
         * @summary Get list of tokens with metadata
         * @param {string} [chainID] The CAIP-2 identifier for a blockchain.
         * @param {string} [tokenAddress] The address of an token contract to query. If omitted, all supported tokens will be queried.
         * @param {string} [tokenSymbol] The symbol of an token contract.
         * @param {Array<string>} [tagLimit] A list of token tag identifiers to include in the query.
         * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokens(chainID, tokenAddress, tokenSymbol, tagLimit, fiatType, options) {
            return localVarFp.getTokens(chainID, tokenAddress, tokenSymbol, tagLimit, fiatType, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TokensApi - object-oriented interface
 */
export class TokensApi extends BaseAPI {
    /**
     * Retrieves a list of available tags that can be used to filter the tokens response.
     * @summary Get list of token tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTokenTags(options) {
        return TokensApiFp(this.configuration).getTokenTags(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves a list of tokens along with their metadata, such as the token\'s name, symbol, decimals, logo URI, and associated tags. This information is useful for displaying token details and allowing users to search or filter tokens based on specific criteria. Tags can be used to narrow down the returned tokens. Example: Use the tag `stablecoins` to only return stablecoin tokens.
     * @summary Get list of tokens with metadata
     * @param {string} [chainID] The CAIP-2 identifier for a blockchain.
     * @param {string} [tokenAddress] The address of an token contract to query. If omitted, all supported tokens will be queried.
     * @param {string} [tokenSymbol] The symbol of an token contract.
     * @param {Array<string>} [tagLimit] A list of token tag identifiers to include in the query.
     * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTokens(chainID, tokenAddress, tokenSymbol, tagLimit, fiatType, options) {
        return TokensApiFp(this.configuration).getTokens(chainID, tokenAddress, tokenSymbol, tagLimit, fiatType, options).then((request) => request(this.axios, this.basePath));
    }
}
